import { render, staticRenderFns } from "./problemAdd.vue?vue&type=template&id=6014f306&scoped=true&"
import script from "./problemAdd.vue?vue&type=script&lang=js&"
export * from "./problemAdd.vue?vue&type=script&lang=js&"
import style0 from "./problemAdd.vue?vue&type=style&index=0&id=6014f306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014f306",
  null
  
)

export default component.exports